import {normalizeMathOptionSpacing} from "./mathOptionSpacing";
import { useEffect } from "react";

const AUTO_SPACE_CLASS = "katex-auto-leading-space";
const NEEDS_PROSE_SPACE = /[\p{L}\p{N}.,;:!?]$/u;

function previousVisibleCharacter(node) {
  let sibling = node?.previousSibling;

  while (sibling) {
    if (sibling.nodeType === Node.TEXT_NODE) {
      const text = sibling.textContent || "";
      if (text.length > 0) return text.slice(-1);
    }

    // Nie rozdzielamy automatycznie dwóch sąsiadujących elementów (np. dwóch
    // wzorów). Reguła dotyczy wyłącznie wzoru przyklejonego do tekstu zdania.
    if (sibling.nodeType === Node.ELEMENT_NODE) return "";
    sibling = sibling.previousSibling;
  }

  return "";
}

export function normalizeInlineMathSpacing(katexNode) {
  if (!(katexNode instanceof Element)) return;
  normalizeMathOptionSpacing(katexNode);

  // `react-katex` dokłada własny span wokół właściwego `.katex`. To właśnie
  // ten zewnętrzny span sąsiaduje z tekstem utworzonym przez Reacta.
  const spacingTarget =
    katexNode.closest('[data-testid="react-katex"]') || katexNode;
  const isDisplayMath = Boolean(katexNode.closest(".katex-display"));
  const previousCharacter = previousVisibleCharacter(spacingTarget);
  const shouldAddSpace =
    !isDisplayMath &&
    previousCharacter !== "" &&
    !/\s/u.test(previousCharacter) &&
    NEEDS_PROSE_SPACE.test(previousCharacter);

  if (spacingTarget !== katexNode) {
    katexNode.classList.remove(AUTO_SPACE_CLASS);
  }
  spacingTarget.classList.toggle(AUTO_SPACE_CLASS, shouldAddSpace);
}

function normalizeWithin(root) {
  if (!(root instanceof Element)) return;
  if (root.matches(".katex")) normalizeInlineMathSpacing(root);
  root.querySelectorAll(".katex").forEach(normalizeInlineMathSpacing);
}

/**
 * Uzupełnia wyłącznie brakujący odstęp między tekstem a wzorem liniowym.
 * Nie zmienia wzorów blokowych ani miejsc, w których odstęp już istnieje.
 */
export default function InlineMathSpacingNormalizer() {
  useEffect(() => {
    normalizeWithin(document.body);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => normalizeWithin(node));
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return null;
}
